import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const Profile = lazy(() => import('../../container/modules/profile/index.js'));
const Search = lazy(() => import('../../container/modules/search/Search'));
const SearchView = lazy(() => import('../../container/modules/search/SearchView'));
const GroupView = lazy(() => import('../../container/modules/search/GroupView'));
const HQView = lazy(() => import('../../container/modules/search/HQView.js'));
const BatchControlView = lazy(() => import('../../container/modules/search/BatchControlView'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="profile" element={<Profile />} />
      <Route path="search" element={<Search />} />
      <Route path="search/view" element={<SearchView />} />
      <Route path="search/group-search/view" element={<GroupView />} />
      <Route path="search/batch-control/view" element={<BatchControlView />} />
      <Route path="search/hq-search/view" element={<HQView />} />
    </Routes>
  );
}

export default PagesRoute;
